import { CircularProgress, ImageList, ImageListItem, ImageListItemBar, useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import { useMinio } from "@tt/ttms-react-core";
import * as React from "react";
import { Identifier, linkToRecord, useListContext } from "react-admin";
import { Link } from "react-router-dom";
import defaultImage from "../video/default.png";

const useStyles = makeStyles((theme) => ({
  gridList: {
    transform: "translateZ(0)",
    margin: 0,
    boxSizing: "border-box",
    justifyContent: "left",
    width: "100%",
  },
  tileBar: {
    background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
  },
  videoThumbnail: {
    maxWidth: "100%",
  },
}));

function useColumns() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.between("xs", "md"));
  const largerThanLg = useMediaQuery(theme.breakpoints.up("lg"));

  let columns = 2;
  if (isSmallScreen) {
    columns = 2;
  }
  if (largerThanLg) {
    columns = 6;
  }
  return columns;
}

const MinioGridThumbnail = ({ objectKey }) => {
  const minio = useMinio();
  const classes = useStyles();
  const minioThumbnail = objectKey === null || typeof objectKey === "undefined" ? defaultImage : minio.convertUrl(objectKey);

  return <img src={minioThumbnail} alt="" className={classes.videoThumbnail} />;
};

const LoadingGridList = () => {
  return <div>{<CircularProgress />}</div>;
};

// const ChapterArrayField = ({ array }) => {
//   if (typeof array === "undefined" || array === null || array.length === 0) {
//     return <div />;
//   } else {
//     return (
//       <>
//         {array.map((item) => (
//           <Chip label={item} size="small" />
//         ))}
//       </>
//     );
//   }
// };

const LoadedGridList = () => {
  const { ids, data, basePath } = useListContext();
  const classes = useStyles();
  const columns = useColumns();

  if (!ids || !data) return null;

  return (
    <ImageList cols={columns} className={classes.gridList}>
      {ids.map((id: Identifier) => (
        <ImageListItem component={Link} key={id} to={linkToRecord(basePath, data[id].id, "show")}>
          <MinioGridThumbnail objectKey={data[id].thumbnailPath} />
          <ImageListItemBar
            className={classes.tileBar}
            title={data[id].title}
            subtitle={<span>Kategori: {data[id].category?.name}</span>}
            //subtitle={<ChapterArrayField array={data[id].chapterId} />}
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
};

const GridList = () => {
  const { loaded } = useListContext();
  return loaded ? <LoadedGridList /> : <LoadingGridList />;
};

export default withWidth()(GridList);
